// Условия списка временного доступа сопровождения (T063; contracts/api.md, GET /api/support-access):
// поиск по ФИО сопровождения или выдавшего, состояние, сортировка по сроку и времени выдачи.
// По умолчанию — все выдачи, новые сверху (-createdAt).
import { supportGrantSortFields, supportGrantStates } from '@kp/contracts';
import type { SortValue, SupportGrantState } from '@kp/contracts';

export type SupportGrantSortField = (typeof supportGrantSortFields)[number];
export type SupportGrantSort = SortValue<SupportGrantSortField>;

export interface SupportAccessSearch {
  q?: string;
  state?: SupportGrantState;
  sort?: SupportGrantSort;
}

export const DEFAULT_SUPPORT_SORT: SupportGrantSort = '-createdAt';

const sortValues = supportGrantSortFields.flatMap((field) => [
  field,
  `-${field}`,
]) as SupportGrantSort[];

/** Для адреса страницы: validateSearch маршрута /support-access. */
export function parseSupportAccessSearch(search: Record<string, unknown>): SupportAccessSearch {
  const result: SupportAccessSearch = {};
  if (typeof search.q === 'string' && search.q.trim() !== '') result.q = search.q;
  if (
    typeof search.state === 'string' &&
    (supportGrantStates as readonly string[]).includes(search.state)
  ) {
    result.state = search.state as SupportGrantState;
  }
  if (typeof search.sort === 'string' && (sortValues as readonly string[]).includes(search.sort)) {
    result.sort = search.sort as SupportGrantSort;
  }
  return result;
}

/** Условия сужают список: «Ничего не найдено» вместо «Доступ не выдавался». */
export function hasFilters(search: SupportAccessSearch): boolean {
  return Boolean(search.q?.trim() || search.state);
}

/** Сортировка: «Сортировка: выдан». */
export const supportSortLabels = {
  createdAt: 'Выдан',
  validUntil: 'Срок',
} as const satisfies Record<SupportGrantSortField, string>;

/** Фильтр «Состояние». */
export const supportStateFilterLabels = {
  active: 'Действующий',
  expired: 'Закончившийся',
  revoked: 'Прекращённый',
} as const satisfies Record<SupportGrantState, string>;
